import { render, staticRenderFns } from "./BindMobile.vue?vue&type=template&id=2fe598cb&scoped=true&"
import script from "./BindMobile.vue?vue&type=script&lang=js&"
export * from "./BindMobile.vue?vue&type=script&lang=js&"
import style0 from "./BindMobile.vue?vue&type=style&index=0&id=2fe598cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe598cb",
  null
  
)

export default component.exports